// Version information for YASGUI
// This file is auto-generated during build - do not edit manually
export const VERSION = "6.2.0";
